import { Box, Button } from '@mui/material';
import { IButton } from './IButton';
export default function CustomisedButton({
    title,
    disable,
    onClick,
    type = 'submit',
    specializedColor
}: IButton) {
    return (
        <Box textAlign="center">
            <Button

                disabled={disable}
                type={type}
                className={`btnClass
                ${title?.includes('انصراف') ? 'bgPrimaryErrorColorLight' : ''}
                 `}
                fullWidth
                sx={{
                    height: '42px',
                    borderRadius: '8px',
                    background: specializedColor ? specializedColor! : 'var(--button-color)',
                    opacity: disable ? 0.4 : 1,
                    "&:hover": {
                        background: specializedColor ? specializedColor! : 'var(--button-color)',
                    },
                    "&:active": {
                        boxShadow: "none",
                        background: specializedColor ? specializedColor! : 'var(--button-color)',
                    },
                    "&:focus": {
                        outline: "none",
                    },
                }}

                onClick={() => onClick()}
            >
                <b className={`text-[0.9rem] ${title?.includes('انصراف') || specializedColor?.includes('#FF617C') ? 'text-[#fff]' : 'primaryColorLight-200'}`}>{title}</b>
            </Button>
        </Box>
    );
}
